<template>
  <b-alert
    v-if="pendingInvoices.length > 0"
    show
    variant="warning"
    class="unpaid-invoice-banner mb-0 rounded-0 text-center"
  >
    <b-icon icon="exclamation-triangle-fill" class="mr-2"></b-icon>
    <span>
      {{ $t('invoices.unpaidBannerMessage', { count: pendingInvoices.length, amount: formatAmount(totalDue, currency) }) }}
    </span>
    <router-link to="/admin/invoices" class="unpaid-invoice-banner__link ml-2">
      {{ $t('invoices.viewInvoices') }}
    </router-link>
  </b-alert>
</template>

<script>
export default {
  name: 'UnpaidInvoiceBanner',
  computed: {
    pendingInvoices() {
      return this.$store.getters.getPendingInvoices
    },
    totalDue() {
      return this.pendingInvoices.reduce(function (sum, inv) {
        return sum + inv.amount_due
      }, 0)
    },
    currency() {
      if (this.pendingInvoices.length > 0) {
        return this.pendingInvoices[0].currency
      }
      return 'USD'
    }
  },
  methods: {
    formatAmount(cents, currency) {
      var currencySymbols = {
        'USD': '$',
        'EUR': '€',
        'RSD': 'RSD'
      }

      var symbol = currencySymbols[currency] || currency
      var amount = (cents / 100).toFixed(2)

      if (currency === 'USD') {
        return symbol + amount
      }

      return amount + ' ' + symbol
    }
  }
}
</script>

<style scoped>
.unpaid-invoice-banner {
  position: sticky;
  top: 55px;
  z-index: 1019;
  font-weight: 500;
  font-size: 0.75rem;
  padding: 6px 16px;
}

.unpaid-invoice-banner__link {
  color: #fff;
  background-color: #856404;
  padding: 2px 8px;
  border-radius: 3px;
  text-decoration: none;
  font-weight: 600;
}

.unpaid-invoice-banner__link:hover {
  background-color: #6c5103;
  color: #fff;
}
</style>
